
var hdTopMaster = new function () {

    this.found = false;
    this.init = function () {
        hdTopMaster.mobileNavigation();
        hdTopMaster.megatopdownNavigation();
        hdTopMaster.megadropdownNavigation();
        hdTopMaster.topHeaderScroll();
        hdTopMaster.checkMenuOpen();
        hdTopMaster.campaignMobileNavigation();
        hdTopMaster.historyBack();

    };
    
    this.historyBack = function() {

        $(".back-btn").click(function () {
            window.history.back();
        });    
    };

    this.mobileNavigation = function () {
        $(".megadropdown-row__menu .h4").click(function (e) {
            e.stopPropagation();
           $(this).parent().children().removeClass("active").removeClass("bordered");
           $(this).addClass("active");           
           var id = $(this).index();
           var menu = $(this).closest(".megadropdown-row").find(".col");
           $(".col").removeClass("active");
           if(id == $(this).parent().children().length-1){
                document.querySelectorAll(".megadropdown-row__menu .h4")[0].classList.add("bordered");
           }
           menu[id].classList.add("active");
        });  

        //toggle mobile menu
        $(".burger-btn:not(.campaign-burger-btn)").click(function () {
            $(this).toggleClass("active");
            //$(this).closest("#top").toggleClass("mobile-nav-open");
            $(".mobile-menu").toggleClass("active");
            $(".mobile-menu-background").toggleClass("active");

            //campaign action
            //$("#mobile-nav").toggleClass("mobile-nav-open");
            if(resetMainSearch !== undefined)
            {
                resetMainSearch();   
            }
        });

         $(".close-menu").click(function () {
            $(".burger-btn").toggleClass("active");
            $(".mobile-menu").toggleClass("active");
            $(".mobile-menu-background").toggleClass("active");
            //$("#mobile-nav").toggleClass("mobile-nav-open");

        });                 

        $(".level ul li .has-children").click(function (e) {
            //$(this).parent().parent().parent().toggleClass("active-level");
            $(this).parent().css("backgroundColor, red");
            $(this).next(".level").addClass("active-level");
            e.preventDefault();
        });

        $(".back-step").click(function () {
            //$(this).parent().parent().parent().toggleClass("active-level");
            $(this).closest(".active-level").removeClass("active-level");
        });

        //on .burger-btn click open burger menu on campaign
        /*$("#mobile-nav .arrow").click(function (e) {
            $(this).parent().toggleClass("active");
            $(this).closest("li").siblings().find("a").removeClass("active");
            e.preventDefault();
        });*/
        $("#mobile-login-expand").click(function(){
            $(".close-menu").trigger("click");
            $("#login-expand").trigger("click");
        });
    }
    this.campaignMobileNavigation = function () {
        $(".campaign-burger-btn").click(function () {
            $(".campaign-burger-btn").toggleClass("active");
            $(".campaign-top").toggleClass("mobile-nav-open"); 
        });


        $(".campaign-mobile-nav a.has-children").click(function (e) {
            var arrow = $(this).find(".arrow");
            if(arrow.size() > 0)
            {
                e.preventDefault();            
                $(this).toggleClass("active");
                arrow.closest("li").siblings().find("a").removeClass("active");                
            }
        });

        //on .burger-btn click open burger menu
        /*$(".campaign-mobile-nav .arrow").click(function (e) {
            $(this).parent().toggleClass("active");
            $(this).closest("li").siblings().find("a").removeClass("active");
            e.preventDefault();
        });*/
    }
    this.megatopdownNavigation = function () {

        //1. Add the natural height to animate (could use a resize)
        /*$(".is-mega-topdown").each(
            function (intIndex) {

            }
        );*/

        //2. We toggle the megatopdown on click (Touch)
        $(".toggle-megatopdown").click(function (e) {

            var topdownId = $(this).data("topdown-id"),
                topdownIdSiblings = $(topdownId).siblings();

            //Toggle topdown
            if (topdownId != '' & topdownId != undefined) {

                if ($(this).hasClass("active")) {
                    //CLOSE
                    //clear all pre-opened header topdowns
                    $(".is-mega-topdown, .is-mega-topdown .header, .toggle-megatopdown, .menu-overlay").removeClass("active");

                    // close all megatopdowns
                    $(".is-mega-topdown").slideUp();
                }
                else {
                    //OPEN
                    //close all siblings
                    $(".toggle-megatopdown").removeClass("active");
                    $(topdownIdSiblings).slideUp();

                    //open active megatopdown
                    $(this).addClass("active");
                    $(".menu-overlay").addClass("active");
                    $(topdownId).slideDown();
                }
            }
            e.stopPropagation();
        });

        $(".close-topdown").click(function () {
            $(".is-mega-topdown, .is-mega-topdown .header, .toggle-megatopdown, .menu-overlay").removeClass("active");
            $(".is-mega-topdown:not(.topdown-search)").slideUp();
        });

        $(".topdown-profile-login .forgot-password").click(function () {
            $('.topdown-profile-login .forgot-password-hidden').slideToggle();
        });

        //close menu if search is focused
        if($(".search-actions input").size() > 0){
            var searchField = $(".search-actions input").focus(function(){
                $(".is-mega-topdown, .is-mega-topdown .header, .toggle-megatopdown, .menu-overlay").removeClass("active");
                $(".is-mega-topdown:not(.topdown-search)").slideUp();                
            });

            $(".search-actions .icon-search").click(function(){
                $(this).parent().toggleClass("mobile-active");
                $(".topdown-search").toggleClass("mobile-active");
            });
        }

        if($(".page-navigation").size() > 0){
            /*$(".page-navigation").click(function(e){
                e.preventDefault();
            });*/
            $(".page-navigation-items-top").click(function(e){
                if($(window).width() < 768)
                {
                    e.preventDefault();
                }
                $(".page-navigation").toggleClass("mobile-active");                
            });
        }

    }
    this.megadropdownNavigation = function () {

        /*Trigger example: 
            <button type="button" class="open-megadropdown" data-dropdown-id="#mega-dropdown-search">
                <i class="fa fa-search"></i>
            </button> 
        */
        
        //1. Add the natural height to animate (could use a resize)
        $( ".is-mega-dropdown" ).each(
            function( intIndex ){

                var thisHeight = $(this).find(".container").outerHeight(); 
                $(this).attr("data-height", thisHeight);
                
            }
        );

        //2. We toggle the megadropdown on click (Touch)
        $(".toggle-megadropdown").click(function (e) {

            var dropdownId =            $(this).data("dropdown-id"),
                dropdownIdHeight =      $(dropdownId).attr("data-height"),
                dropdownIdSiblings =    $(dropdownId).siblings();
           

            //Toggle dropdown
            if (dropdownId != '' & dropdownId != undefined ) { 

                if($(this).hasClass("active")) {
                    //CLOSE
                    //clear all pre-opened header dropdowns
                    $(".is-mega-dropdown, .is-mega-dropdown .header, .toggle-megadropdown, .menu-overlay").removeClass("active"); 

                    //close all megadropdowns

                    TweenMax.to($(".is-mega-dropdown"), .8, { height: 0, ease: Power4.easeOut }); 
                }
                else {
                    //OPEN
                    //close all siblings
                    $(".toggle-megadropdown").removeClass("active"); 
                    TweenMax.to($(dropdownIdSiblings), .8, { height: 0, ease: Power4.easeOut }); 

                    //open active megadropdown
                    $(this).addClass("active");
                    $(".menu-overlay").addClass("active");
                    TweenMax.to(dropdownId, .8, { height: dropdownIdHeight, ease: Power4.easeOut }); 
                }
            }
            if(resetMainSearch != undefined){
                resetMainSearch();
            }
            e.stopPropagation();
        });


        //3: close megadropdown on mouse out
        $( ".is-mega-dropdown").mouseleave(function() {
            //clear all pre-opened header dropdowns
            $(".is-mega-dropdown, .is-mega-dropdown .header, .toggle-megadropdown, .menu-overlay").removeClass("active"); 

            //close all megadropdowns
            TweenMax.to($(".is-mega-dropdown"), .8, { height: 0, ease: Power4.easeOut }); 
                    
        });


        /*
        //(Alt 2).  We toggle the megadropdown on hover (Non touch)
        //(2.1) If hover on .toggle-megadropdown items open it´s megadropdown
        $(".no-touchevents .toggle-megadropdown").mouseover(function (e) {

            var dropdownId =            $(this).data("dropdown-id"),
                dropdownIdHeight =      $(dropdownId).attr("data-height"),
                dropdownIdSiblings =    $(dropdownId).siblings();

            //Toggle dropdown
            if (dropdownId != '' & dropdownId != undefined ) { 

                if($(this).hasClass("active")) {
                    //CLOSE
                    //clear all pre-opened header dropdowns
                    $(".is-mega-dropdown, .is-mega-dropdown .header, .toggle-megadropdown").removeClass("active"); 
                    
                    //close all megadropdowns
                    TweenMax.to($(".is-mega-dropdown"), .8, { height: 0, ease: Power4.easeOut }); 
                }
                else {
                    //OPEN
                    //close all siblings
                    $(".toggle-megadropdown").removeClass("active"); 
                    TweenMax.to($(dropdownIdSiblings), .8, { height: 0, ease: Power4.easeOut }); 

                    //open active megadropdown
                    $(this).addClass("active");
                    TweenMax.to(dropdownId, .8, { height: dropdownIdHeight, ease: Power4.easeOut }); 
                }
            }

            e.stopPropagation();
        });


        //(3.2) If hover on non .toggle-megadropdown items close all megadropdowns
        $("#primary-nav a:not(.toggle-megadropdown), #secondary-nav a:not(.toggle-megadropdown)").mouseover(function (e) {

            //CLOSE
            //clear all pre-opened header dropdowns
            $(".is-mega-dropdown, .is-mega-dropdown .header, .toggle-megadropdown").removeClass("active"); 
            
            //close all megadropdowns
            TweenMax.to($(".is-mega-dropdown"), .8, { height: 0, ease: Power4.easeOut }); 

        });
        */

    }
    this.topHeaderScroll = function() {

        if (!$('html').hasClass('lt-ie9')){
            //Make the top header slimmer when scrolled pass by it
            function yScroll(){
                var pagetop = $("#top"),
                yPos = window.pageYOffset;
                
                if(yPos > 120){
                    $("body").addClass("top-slim-header");
                } else {
                    $("body").removeClass("top-slim-header");
                }
            }

            if($('html').hasClass("no-touchevents")) {
                window.addEventListener("scroll", yScroll);
            }
        }

    }
    this.checkMenuOpen = function(){
        //check for querystring param and if it exists, 
        //force menu open on initial load by subnav id, e.g. top-subnav-login

        //example of opening when appending ?email to a link from e.g. a email send to customer.
        hdTopMaster.openMenu("email", "top-subnav-login");
        //Shows profile menu rigt after login
        hdTopMaster.openMenu("email", "top-subnav-profile");

        //if password is incorrect, ?login could be appended to reopen login if login is incorrect so the error message is visible.
        hdTopMaster.openMenu("login", "top-subnav-login");
        //Shows profile menu rigt after login
        hdTopMaster.openMenu("login", "top-subnav-profile");

        hdTopMaster.openMenu("reset", "forgot-password-hidden");

        // Contains possible queryParameters where url should not be rewritten
        if (getParameterByName("Groups") || getParameterByName("SystemWebConcept") || getParameterByName("SectorsWeb") || getParameterByName("Application") || getParameterByName("Design") || getParameterByName("Compliance") || getParameterByName("Colour")) {           
            hdTopMaster.found = false;
        }

        if (hdTopMaster.found) {
            var stateObj = { vikan: "landingpage" };
            history.pushState(stateObj, document.title, "./");
        }        
    }   
    this.openMenu = function (param, id, override) {
        
        if(getParameterByName(param) != null){
            if ($("#" + id).size() > 0) {
                $("#" + id).css("display","block");
                $(".menu-overlay").addClass("active");

                //change page history when arriving on landing page, otherwise navigating away from the page 
                //will carry over the query string and open the menu again.
                hdTopMaster.found = true;

            }
        }
    }
}

$(document).ready(function () {
    hdTopMaster.init();
});

// Nav icon dropdown (Vanilla)
const navDropdownIcon = document.querySelector(".contact-icon");
const navDropdownParent = document.querySelector("#contact-item-parent");

navDropdownIcon.addEventListener("click", (e) => {
    e.stopPropagation();
    navDropdownParent.classList.toggle("contact-dropdown-active");
    navDropdownIcon.classList.toggle("contact-dropdown-active");
});

navDropdownParent.addEventListener("click", (e) => {
    e.stopPropagation();
});

// Close contact dropdown on outside click
document.addEventListener("click", (e) => {
    
    navDropdownParent.classList.remove("contact-dropdown-active")
    navDropdownIcon.classList.remove("contact-dropdown-active");
});
